// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_session_tree_view from "./web_session_tree_view.js";
import * as Mapre_web__Web_sidebar_menu from "./web_sidebar_menu.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib from "melange/stdlib.js";

function sessions(send, source) {
  const partial_arg = Signal.map((function (m) {
    return [
      Mapre_web__Web_types.workspace(m.route),
      Mapre_web__Web_types.project(m.route)
    ];
  }), source);
  return function (param, param$1) {
    return Lui_elements.dyn(undefined, (function (param) {
      const workspace = param[0];
      if (workspace !== undefined) {
        const project = param[1];
        if (project !== undefined) {
          return Mapre_web__Web_session_tree_view.view(source, send, workspace, project);
        }
        
      }
      return function (param, param$1) {
        return Lui_elements.column(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), partial_arg, param, param$1);
  };
}

function footer(send, source) {
  const partial_arg = "Mapre home";
  const partial_arg$1 = {
    TAG: /* Navigate */ 0,
    _0: /* Home */ 0
  };
  const partial_arg$2 = (function (param) {
    return Lui_elements.press(send, partial_arg$1, param);
  });
  const partial_arg$3 = "Mapre home";
  const partial_arg$4 = {
    NAME: "app",
    VAL: "folder"
  };
  const partial_arg$5 = "icon";
  const partial_arg$6 = "ghost";
  const partial_arg$7 = "Settings";
  const partial_arg$8 = {
    TAG: /* Settings */ 37,
    _0: {
      TAG: /* Open */ 0,
      _0: ""
    }
  };
  const partial_arg$9 = (function (param) {
    return Lui_elements.press(send, partial_arg$8, param);
  });
  const partial_arg$10 = "Settings";
  const partial_arg$11 = {
    NAME: "app",
    VAL: "settings"
  };
  const partial_arg$12 = "icon";
  const partial_arg$13 = "ghost";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, partial_arg$5, partial_arg$4, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$13, partial_arg$12, partial_arg$11, undefined, undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, partial_arg$7, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.scoped((function (__lui_context___001_) {
          const partial_arg = "Accounts";
          const partial_arg$1 = {
            TAG: /* Accounts */ 41,
            _0: {
              TAG: /* Open */ 0,
              _0: ""
            }
          };
          const partial_arg$2 = (function (param) {
            return Lui_elements.press(send, partial_arg$1, param);
          });
          const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (m) {
            return m.current_user === undefined;
          }), source)));
          const partial_arg$4 = "Accounts";
          const partial_arg$5 = {
            NAME: "app",
            VAL: "user"
          };
          const partial_arg$6 = "icon";
          const partial_arg$7 = "ghost";
          return function (param, param$1) {
            return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, partial_arg$6, partial_arg$5, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, partial_arg$3, partial_arg$2, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
        }), param, param$1);
      }),
      tl: /* [] */ 0
    }
  };
  const partial_arg$14 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$15 = "sidebar-foot";
  const partial_arg$16 = 4;
  const partial_arg$17 = 4;
  return function (param, param$1) {
    return Lui_elements.row(undefined, partial_arg$17, undefined, undefined, undefined, undefined, undefined, partial_arg$16, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$15, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, param, param$1);
  };
}

function header(send, source) {
  const partial_arg = (function (param) {
    return Lui_elements.press(send, /* Toggle_sidebar */ 14, param);
  });
  const partial_arg$1 = "Hide sidebar";
  const partial_arg$2 = {
    NAME: "app",
    VAL: "panel-left"
  };
  const partial_arg$3 = "icon";
  const partial_arg$4 = "ghost";
  const partial_arg_0 = Mapre_web__Web_sidebar_menu.workspace(send, source);
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___002_) {
        const partial_arg = (function (param) {
          return Lui_elements.press(send, /* Toggle_sidebar_search */ 13, param);
        });
        const partial_arg$1 = "Search chats";
        const partial_arg$2 = {
          NAME: "app",
          VAL: "search"
        };
        const partial_arg$3 = "icon";
        const partial_arg$4 = "ghost";
        const partial_arg$5 = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (m) {
          return {
            hd: [
              "aria-expanded",
              Stdlib.string_of_bool(m.sidebar_search_open)
            ],
            tl: /* [] */ 0
          };
        }), source)));
        return function (param, param$1) {
          return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, partial_arg$2, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, partial_arg$2, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      }),
      tl: /* [] */ 0
    }
  };
  const partial_arg$5 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$6 = 0;
  const partial_arg$7 = "center";
  const partial_arg$8 = 2;
  return function (param, param$1) {
    return Lui_elements.row(undefined, partial_arg$8, undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, param, param$1);
  };
}

function view(send, source) {
  const partial_arg = {
    TAG: /* Open_form */ 15,
    _0: ""
  };
  const partial_arg$1 = (function (param) {
    return Lui_elements.press(send, partial_arg, param);
  });
  const partial_arg$2 = {
    NAME: "app",
    VAL: "edit"
  };
  const partial_arg$3 = "ghost";
  const partial_arg$4 = "New chat";
  const partial_arg$5 = "start";
  const partial_arg$6 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$7 = Signal.map((function (m) {
    if (Mapre_web__Web_model.can_create(m)) {
      return Mapre_web__Web_types.project(m.route) !== undefined;
    } else {
      return false;
    }
  }), source);
  const partial_arg$8 = "Sessions";
  const partial_arg$9 = "nav-eyebrow";
  const partial_arg_0 = sessions(send, source);
  const partial_arg$10 = {
    hd: partial_arg_0,
    tl: /* [] */ 0
  };
  const partial_arg$11 = 0;
  const partial_arg$12 = 0;
  const partial_arg$13 = 1;
  const partial_arg$14 = (function (param) {
    return Lui_elements.press(send, /* More_sessions */ 9, param);
  });
  const partial_arg$15 = "sm";
  const partial_arg$16 = "ghost";
  const partial_arg$17 = "More sessions";
  const partial_arg$18 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$17, undefined, partial_arg$16, partial_arg$15, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$19 = Signal.map((function (m) {
    return m.next_session !== undefined;
  }), source);
  const partial_arg_0$1 = header(send, source);
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___004_) {
        const partial_arg = Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (m) {
          return m.sidebar_search_open;
        }), source));
        return function (param, param$1) {
          return Lui_elements.if_(partial_arg, (function (param, param$1) {
            return Lui_elements.scoped((function (__lui_context___005_) {
              const partial_arg = (function (param) {
                return Lui_elements.on_input(send, (function (v) {
                  return {
                    TAG: /* Search_sessions */ 49,
                    _0: v
                  };
                }), param);
              });
              const partial_arg$1 = true;
              const partial_arg$2 = "Search chats";
              const partial_arg$3 = "Search chats";
              const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (m) {
                return m.session_query;
              }), source)));
              return function (param, param$1) {
                return Lui_elements.search_field(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), param, param$1);
          }), param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$7, partial_arg$6, param, param$1);
      }),
      tl: {
        hd: Mapre_web__Web_sidebar_menu.project(send, source),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.column(undefined, undefined, undefined, undefined, partial_arg$13, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$12, undefined, undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, param, param$1);
            }),
            tl: {
              hd: (function (param, param$1) {
                return Lui_elements.if_(partial_arg$19, partial_arg$18, param, param$1);
              }),
              tl: {
                hd: footer(send, source),
                tl: /* [] */ 0
              }
            }
          }
        }
      }
    }
  };
  const partial_arg$20 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1
  };
  const partial_arg$21 = "sidepane";
  const partial_arg$22 = 0;
  const partial_arg$23 = 280;
  const partial_arg$24 = 8;
  const partial_arg$25 = 6;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$25, undefined, undefined, undefined, undefined, undefined, partial_arg$24, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$23, undefined, partial_arg$22, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$21, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$20, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
